var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('Sidebar'),_c('Header'),_c('main',{staticClass:"main"},[_c('Promo'),_c('AboutUs'),_c('Activities'),_c('Causes'),_c('Projects'),_c('Events'),_c('Build'),_c('Testimonials'),_c('Articles'),_c('Sponsors'),_c('Social'),_c('Subscribe')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }